export default (state: { sale: { saleContext: bb.model.sale.ISaleContext } }) =>
  state.sale.saleContext;
